export default __webpack_public_path__ + "images/71528e7dd5c72326c722ba250e02fe24-pagination_infinite_dont.svg";